import Clarity from '@microsoft/clarity';

const COOKIE_CONSENT_KEY = 'cookie-consent';
const CLARITY_ID = 'v80ydsajdl';

export type CookieConsentValue = 'accepted' | 'rejected';

export function getCookieConsent(): CookieConsentValue | null {
  try {
    const value = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (value === 'accepted' || value === 'rejected') return value;
    return null;
  } catch {
    return null;
  }
}

export function setCookieConsent(value: CookieConsentValue): void {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, value);
  } catch {
    // localStorage indisponible (navigation privée, etc.)
  }
}

/** Initialise Clarity uniquement si le consentement a été accepté */
export function initAnalytics(): void {
  if (getCookieConsent() === 'accepted') {
    Clarity.init(CLARITY_ID);
  }
}
